package com.exura.components.layouts.plan

import com.exura.components.inputs.ModeToggleOption
import com.exura.features.planConstruction.planConstructionLocalization
import com.exura.ui.Assets

enum class LayoutMode {
    EDIT, VIEW;
}

internal val LAYOUT_MODES_ITEMS = listOf(
    ModeToggleOption(
        LayoutMode.VIEW,
        planConstructionLocalization.current.toggles.layoutModeView,
        Assets.IconsUntiled.EYE_OPEN,
    ),
    ModeToggleOption(
        LayoutMode.EDIT,
        planConstructionLocalization.current.toggles.layoutModeEdit,
        Assets.IconsUntiled.EDIT,
    ),
)
